import SubheaderBackButton from "components/FutureNavBasedComponents/SubheaderBackButton";
import { ReactNode } from "react";

interface UnderHeaderSectionProps {
  backButtonLabel: string;
  onBackButtonClick: () => void;
  pageMainHeader: string;
  pageSubheader?: JSX.Element | ReactNode | string;
}

const UnderHeaderSection = ({ backButtonLabel, onBackButtonClick, pageMainHeader, pageSubheader }: UnderHeaderSectionProps) => {
  return (
    <div className="pl-[35px]">
      <SubheaderBackButton label={backButtonLabel} onClick={onBackButtonClick} className="pb-3 " />
      
      <h2 className="text-[28px] font-light">{pageMainHeader}</h2>

      {
        pageSubheader &&(
          <p>{pageSubheader}</p>
        )
      }
    </div>
  );
};

export default UnderHeaderSection;
